/**
 * Trigger download for any file URL
 */
export const downloadFile = (
  url: string,
  target: '_blank' | '_top' = '_blank'
): void => {
  const link = document.createElement('a');
  link.href = url;
  link.download = '';
  link.target = target;
  link.rel = 'noopener noreferrer';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
